/** 加载骨架屏组件 */

import { Box, Skeleton } from '@mui/material';

export interface LoadingSkeletonProps {
  type?: 'table' | 'card' | 'page';
  rows?: number;
}

export default function LoadingSkeleton({ type = 'page', rows = 5 }: LoadingSkeletonProps) {
  if (type === 'table') {
    return (
      <Box sx={{ p: 3 }}>
        <Skeleton variant="rectangular" height={48} sx={{ mb: 1, borderRadius: 1 }} />
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="rectangular" height={40} sx={{ mb: 0.5, borderRadius: 1 }} />
        ))}
      </Box>
    );
  }

  if (type === 'card') {
    return (
      <Box sx={{ p: 2 }}>
        <Skeleton variant="rectangular" height={160} sx={{ borderRadius: 2 }} />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
      <Skeleton variant="circular" width={48} height={48} />
      <Skeleton variant="rectangular" width="60%" height={24} sx={{ borderRadius: 1 }} />
      <Skeleton variant="rectangular" width="40%" height={16} sx={{ borderRadius: 1 }} />
    </Box>
  );
}
